export enum NotificationsMutations {
  RESET = "RESET",
  SET_NOTIFICATIONS = "SET_NOTIFICATIONS",
  SET_NOTIFICATION_READ = "SET_NOTIFICATION_READ",
}
